<template>
  <div class="app-container">
    <!-- <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane label="横版" name="shu"/>
      <el-tab-pane label="竖版" name="heng"/>
    </el-tabs> -->
    <template v-if="activeName === 'shu'">
      <shu/>
    </template>
    <template v-else>
      <heng/>
    </template>

  </div>
</template>

<script>
import Shu from './shu.vue'
import Heng from './heng.vue'
export default {
  components: { Shu, Heng },
  data() {
    return {
      activeName: 'shu'
    }
  },
  created() {
  },
  methods: {
  }
}
</script>

<style lang="scss" scoped>
::v-deep{
  .el-tabs{
    background-color: white;
    padding: 0 15px;
  }
}
</style>
